(function () {
  function buildZoneUrl(currentHref, zone, filterParam) {
    var url = new URL(currentHref, window.location.origin);
    url.searchParams.delete('page');
    url.searchParams.delete(filterParam);

    if (zone) {
      url.searchParams.set(filterParam, zone);
    }

    return url.pathname + (url.search ? url.search : '');
  }

  function initZoneFinder(root) {
    var form = root.querySelector('[data-sv-zone-form]');
    var select = root.querySelector('[data-sv-zone-select]');
    var result = root.querySelector('[data-sv-zone-result]');
    var resultZone = root.querySelector('[data-sv-zone-result-zone]');
    var filterParam = root.getAttribute('data-filter-param') || 'filter.p.m.custom.canadian_garden_zones';
    var mapsUrl = root.getAttribute('data-maps-url') || '/pages/grow-zone-maps';

    if (!form || !select) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var zone = select.value;
      if (!zone) {
        window.location.href = mapsUrl;
        return;
      }

      if (result && resultZone) {
        result.hidden = false;
        resultZone.textContent = zone;
      }

      window.location.href = buildZoneUrl(window.location.href, zone, filterParam);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sv-zone-finder]').forEach(initZoneFinder);
  }

  window.CasaVerdeZoneFinder = {
    buildZoneUrl: buildZoneUrl,
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
